<template>
  <v-container fluid grid-list-xl>
    <v-layout column>
      <v-flex>
        <upload-box v-if="$store.getters.hasPermission('edit_organization_media')"></upload-box>
      </v-flex>
      <v-flex>
        <media-table></media-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UploadBox from './UploadBox.vue';
import MediaTable from './MediaTable.vue';

export default {
  components: {
    UploadBox,
    MediaTable,
  },
};
</script>

<style>

</style>
